export const BACKUP_LOGO_NAME = 'logo_not_found'
